import BaseListPage from "../../base/BaseListPage";
import withRouter from "../../withRouter";
import { countObjectUseCase, findObjectUseCase } from "../../usecases/object";
import NavBar from "../../components/navbar";
import schemaDashboard from "./schemaDashboard.json";
import CustomerPresenter from "./CustomerPresenter";
import CustomerCountPage from "./chart/customer-count/CustomerCountPage";
import SalesPerSegmentPage from "./chart/sales-per-segment/SalesPerSegmentPage";
import CustomerBreakdownPage from "./chart/customer-breakdown/CustomerBreakdownPage";
import Top5ProductsBuyPage from "./chart/top5-products-buy/Top5ProductsBuyPage";
import CustomerSalesPerStorePage from "./chart/customer-sales-per-store/CustomerSalesPerStorePage";
import ProgressLoader from "../../components/ProgressLoader";
import PageHeader from "../../components/PageHeader";
import ViewModeSelect from "./components/ViewModeSelect";
import SchemaDashboard from "./components/SchemaDashboard";

class CustomerPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new CustomerPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
    );
    this.state = {
      objects: [],
      selected: [],
      progress: true,
      count: 0,
      where: {},
      selectedOption: "",
      store: [],
      storess: "",
      range: "",
      loading: false,
      notFound: false,
      enriched: null,
      totalChunks: 0,
      runningChunks: 0,
    };
  }

  getCollectionName() {
    return "transactions";
  }

  onChangeDate(where) {
    this.presenter.onChangeDate(where);
    this.setState({ range: where });
  }

  onChangeStore(where) {
    this.presenter.onChangeStore(where);
    this.setState({ storess: where });
  }

  handleCountClick(nav) {
    this.navigateTo(nav);
  }

  handleSelectChange = (event) => {
    this.setState({ selectedOption: event.target.value, loading: true });

    setTimeout(() => {
      this.setState({ loading: false });
    }, 1000);
  };

  setStore(store) {
    this.setState({ store });
  }

  getProgressPercentage() {
    const { runningChunks, totalChunks } = this.state;
    if (!totalChunks || totalChunks === 0) return 0;
    return Math.min(Math.round((runningChunks / totalChunks) * 100), 100);
  }

  setNotFound(notFound) {
    this.setState({ notFound });
  }

  setEnrichedTransactions(enriched) {
    this.setState({ enriched: enriched });
  }

  setAllChunks(totalChunks) {
    this.setState({ totalChunks: totalChunks });
  }

  setRunningChunks(runningChunks) {
    this.setState({ runningChunks: runningChunks });
  }

  render() {
    const { objects, enriched, totalChunks, store, loading } = this.state;

    return (
      <>
        <NavBar />
        <div className="overflow-auto">
          <div className="p-3 p-lg-4">
            <div className="d-flex justify-content-between align-items-center">
              <PageHeader
                title="Customer Analytics"
                subtitle="Customer volume and visit trends"
                icon="bi bi-graph-up"
              />
            </div>
            <SchemaDashboard schemaDashboard={schemaDashboard} />
            {/* <ProgressLoader
              loaded={this.state.runningChunks}
              total={this.state.totalChunks}
              getProgressPercentage={() => this.getProgressPercentage()}
            /> */}
            <CustomerCountPage
              transactions={enriched || []}
              onChangeDate={this.onChangeDate.bind(this)}
              onChangeStore={this.onChangeStore.bind(this)}
              dateField="tran_date"
              store={store}
              storess={this.state.storess}
              range={this.state.range}
              notFound={this.state.notFound}
            />
            <SalesPerSegmentPage
              transactions={enriched || []}
              onChangeDate={this.onChangeDate.bind(this)}
              onChangeStore={this.onChangeStore.bind(this)}
              dateField="tran_date"
              store={store}
              storess={this.state.storess}
              range={this.state.range}
              notFound={this.state.notFound}
            />

            <ViewModeSelect
              value={this.state.selectedOption}
              onChange={(val) =>
                this.handleSelectChange({ target: { value: val } })
              }
              options={[
                { value: "top5", label: "Top 5 Products that Customers Buy" },
                { value: "breakdown", label: "Customer Breakdown" },
              ]}
            />

            {loading ? (
              <div className="text-center mt-4">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <>
                {this.state.selectedOption === "top5" && (
                  <Top5ProductsBuyPage
                    transactions={objects}
                    storess={this.state.storess}
                    range={this.state.range}
                  />
                )}
                {this.state.selectedOption === "breakdown" && (
                  <CustomerBreakdownPage transactions={this.state.enriched} />
                )}
                {this.state.selectedOption === "customer" && (
                  <CustomerSalesPerStorePage
                    transactions={this.state.enriched}
                  />
                )}
              </>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(CustomerPage);
